/**
 * Stripe checkout helpers.
 *
 * Creates a Stripe Checkout session via the edge function,
 * then redirects the user to the Stripe-hosted checkout page.
 */

const CHECKOUT_URL = '/api/stripe-checkout';

export async function redirectToCheckout(userId: string, accessToken: string): Promise<void> {
  const response = await fetch(CHECKOUT_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ user_id: userId }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error ?? 'Failed to create checkout session');
  }

  const { url } = await response.json();
  if (url) {
    window.location.href = url;
  } else {
    throw new Error('No checkout URL returned');
  }
}
